const MortgageCompanyPaymentsHeaders = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxID',
    sortable: false,
  },
  {
    text: 'Parcel ID',
    value: 'parcelID',
    sortable: false,
  },
  {
    text: 'Mortgage Code',
    value: 'mortgageCode',
    sortable: false,
  },
  {
    text: 'Mortgage Comp Name',
    value: 'mortgageCompName',
    sortable: false,
  },
  {
    text: 'Amount',
    value: 'amt',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'TRtaxID',
    sortable: false,
    enableLine: true,
    class: 'with-divider-left',
  },
  {
    text: 'Amount Due',
    value: 'amtDue',
    sortable: false,
  },
  {
    text: 'Mortage Code',
    value: 'TRmortgageCode',
    sortable: false,
  },
  {
    text: 'Error Flag',
    value: 'errFlag',
    sortable: false,
  },
];

const MortgageCompanyPaymentsHeadersTwo = {
  MainHeadersNames: [
    {
      text: 'Information from Mortgage Company File',
      cols: '6',
      id: 1,
    },
    {
      text: 'Information from Tax Roll',
      cols: '4',
      cellClass: 'with-divider-left',
      id: 3,
    },
  ],
};

const MtgBillRequestsHeaders = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Parcel ID',
    value: 'propertyOrParcelId',
    sortable: false,
  },
  {
    text: 'Name from Mtg Co',
    value: 'nameFromMtgComp',
    sortable: false,
  },
  {
    text: 'Tax ID',
    // for only display purpos
    value: 'taxIdFromTaxRoll',
    sortable: false,
    enableLine: true,
    class: 'with-divider-left',
  },
  {
    text: 'Mortage Code',
    value: 'mtgCode',
    sortable: false,
  },
  {
    text: 'Name on Tax Roll',
    value: 'ownerName',
    sortable: false,
  },
];

const MtgBillRequestsHeadersTwo = {
  MainHeadersNames: [
    {
      text: 'Information from Mortgage Company File',
      cols: '4',
      id: 1,
    },
    {
      text: 'Information from Tax Roll',
      cols: '4',
      cellClass: 'with-divider-left',
      id: 3,
    },
  ],
};

const lockboxHeaders = [
  {
    text: 'Batch #',
    value: 'batchNo',
    sortable: false,
  },
  {
    text: 'Seq',
    value: 'seq',
    sortable: false,
  },
  {
    text: 'Year',
    value: 'year',
    sortable: false,
  },
  {
    text: 'Tax Id',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Original Pmt',
    value: 'originalPmt',
    sortable: false,
  },
  {
    text: 'Tax Paid',
    value: 'taxPaid',
    sortable: false,
  },
  {
    text: 'Penalty Paid',
    value: 'penaltyPaid',
    sortable: false,
  },
  {
    text: 'Fees Paid',
    value: 'feesPaid',
    sortable: false,
  },
  {
    text: 'Amount Not Paid',
    value: 'amtNotPaid',
    sortable: false,
    enableLine: true,
    class: 'with-divider-left',
  },
  {
    text: 'Tax Id',
    value: 'taxId',
    sortable: false,
    enableLine: true,
    class: 'with-divider-left',
  },
  {
    text: 'Amount Due',
    value: 'amtDue',
    sortable: false,
  },
  {
    text: 'Mtg Code',
    value: 'mtgCode',
    sortable: false,
  },
  {
    text: 'Match',
    value: 'match',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'validationStatus',
    sortable: false,
  },
  {
    text: 'Message',
    value: 'message',
    sortable: false,
    enableLine: true,
    class: 'with-divider-left',
  },
];

const lockboxHeadersTwo = {
  MainHeadersNames: [
    {
      text: 'Information from Bank',
      cols: '8',
      id: 1,
    },
    {
      text: '',
      cols: '1',
      cellClass: 'with-divider-left',
      id: 2,
    },
    {
      text: 'Information from Tax Roll',
      cols: '4',
      cellClass: 'with-divider-left',
      id: 3,
    },
    {
      text: '',
      cols: '1',
      cellClass: 'with-divider-left',
      id: 4,
    },
  ],
};

export {
  MortgageCompanyPaymentsHeaders, MortgageCompanyPaymentsHeadersTwo, MtgBillRequestsHeaders,
  MtgBillRequestsHeadersTwo, lockboxHeaders, lockboxHeadersTwo,
};
